export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();

  router.afterEach((to) => {
    if (!import.meta.client) return;
    // The SSO callback lands as /auth/callback?sso=success&code=<uuid>, and that
    // code exchanges for a customer session. `to.fullPath` is a router value
    // resolved at navigation time, so the address-bar scrub in
    // 01-redact-credential-url.client.ts cannot reach it. Skip the page: it is an
    // interstitial that redirects immediately, and the outcome is already tracked
    // by sso_login_failed / login_completed. ($current_url, which mixpanel-browser
    // attaches to every event from window.location.href, is covered by that scrub.)
    // Same for the Login as landing: `?loginAs=` carries a live customer JWT.
    if (to.path === "/auth/callback" || "loginAs" in to.query) return;

    const mixpanel = nuxtApp.$mixpanel as
      | { track: (event: string, props: Record<string, unknown>) => void }
      | undefined;
    if (!mixpanel) return;

    mixpanel.track("Page Viewed", {
      path: to.fullPath,
      name: to.name as string,
    });
  });
});
